<rv-sortable [sortableService]="sortableService">
  @for (comp of components; track comp; let key = $index) {
    @let componentVisibility = getComponentVisibility(comp);
    @let componentRequiresUpgrade = requiresUpgrade(comp);
    @let componentIcon = getComponentIcon(comp);

    <div
      rvSortableItem
      class="component-item"
      tabindex="0"
      [class.component-item-disabled]="
        componentRequiresUpgrade || !componentVisibility
      "
      [class.component-item-editing-label]="comp.editing"
      (mouseenter)="onAttributeRowMouseEnter(comp)"
      (mouseleave)="onAttributeListMouseLeave()"
      (keyup.enter)="onComponentItemEnterKeyup(comp, key, $event)"
    >
      @if (isUserComponents) {
        <rv-sortable-handle></rv-sortable-handle>
      }
      <div class="component-item-label">
        <div
          class="component-item-label-main"
          (click)="
            !componentRequiresUpgrade &&
              componentVisibility &&
              editComponent(comp, key)
          "
        >
          <mat-icon
            aria-hidden="true"
            [svgIcon]="componentIcon"
            [class.tw-ml-[8px]]="isUserComponents"
          ></mat-icon>
          <span
            id="component-edit-{{ key }}-{{
              isUserComponents ? 'user' : 'base'
            }}"
            class="component-item-label-text"
            [focus-outline]="-2"
            [hidden]="comp.editing"
            [class.danger]="comp.fileMissing"
          >
            {{ getDisplayName(comp) }}
          </span>
          <div [shown]="comp.editing" class="mr-2 flex-grow">
            <input
              #ComponentName
              id="input-component-name-{{ key }}"
              aria-label="Edit component label"
              attr.aria-describedby="component-edit-{{ key }}-{{
                isUserComponents ? 'user' : 'base'
              }}"
              class="w-100 form-control p-2 h-auto"
              type="text"
              [ngModel]="getDisplayName(comp)"
              (blur)="saveItemName(key, $event)"
              (keyup)="itemNameKeyup(key, $event)"
            />
          </div>
        </div>
        @if (componentRequiresUpgrade) {
          @if (isPowerBi(comp)) {
            <upgrade-notice #UpgradeNotice feature="power_bi"></upgrade-notice>
          } @else if (isDomo(comp)) {
            <upgrade-notice #UpgradeNotice feature="domo"></upgrade-notice>
          }
        }
      </div>
      @if (!componentRequiresUpgrade) {
        <div class="component-item-actions">
          <template-attribute-components-menu-inline
            class="component-item-menu-inline"
            [key]="key"
            [isUserComponents]="isUserComponents"
            [componentVisibility]="componentVisibility"
            [componentRequiresUpgrade]="componentRequiresUpgrade"
            [isDataComponent]="isDataComponent(comp)"
            [displayName]="getDisplayName(comp)"
            (rename)="renameComponent($event)"
            (visibilityChange)="setComponentVisibility(comp, $event)"
            (duplicate)="duplicateComponent($event)"
            (remove)="removeComponent($event)"
          ></template-attribute-components-menu-inline>

          @if (comp.fileMissing) {
            <mat-icon
              aria-label="Missing file"
              svgIcon="warning-filled"
              color="warn"
              class="file-missing-icon"
              matTooltip="Missing file"
              matTooltipClass="menu-tooltip"
            ></mat-icon>
          }

          <template-attribute-components-menu-dropdown
            class="component-item-menu-dropdown"
            [key]="key"
            [isUserComponents]="isUserComponents"
            [componentVisibility]="componentVisibility"
            [componentRequiresUpgrade]="componentRequiresUpgrade"
            [isDataComponent]="isDataComponent(comp)"
            [displayName]="getDisplayName(comp)"
            (rename)="renameComponent($event)"
            (visibilityChange)="setComponentVisibility(comp, $event)"
            (duplicate)="duplicateComponent($event)"
            (remove)="removeComponent($event)"
          ></template-attribute-components-menu-dropdown>
        </div>
      }
    </div>
  }
</rv-sortable>
